import FieldMixins from './mixins/field_mixin.js';

const SectionBreak = Vue.extend({
  mixins: [FieldMixins],

  template: `
    <FieldView :editing='editing'
               :field='field'
               :field_groups='field_groups'
               :layouts='availableLayouts'
               ref='fieldView'>
    </FieldView>
  `
});

export default SectionBreak;
